import { LIBRARY_VERSION } from "./library.js";
import { obligations } from "./engine.js";
export const LIBRARY_RELEASES = [
    { version: "0.1.0", date: "2026-10-13", summary: "First release: UK, EU and Australian obligations; 18 controls crosswalked to seven frameworks." },
    { version: "0.2.0", date: "2026-10-17", summary: "Added the United States: federal law plus state AI laws for CA, CO, CT, IL, NY, NYC, TX and UT.",
        added: ["us-ftc", "us-civil-rights", "us-credit", "us-omb", "us-nist", "us-preemption", "ca-tfaia", "ca-caita", "ca-admt", "ca-risk", "ca-feha",
            "co-admt-deployer", "co-admt-developer", "il-hra", "il-frontier", "ny-raise", "nyc-ll144", "ct-aedt", "tx-traiga", "ut-disclosure"] },
    { version: "0.3.0", date: "2026-10-17", summary: "Supply model: systems built and used in-house now carry both provider and deployer duties. Supplier control C16 applies to bought-in systems and third-party components. Credit and California ADMT duties apply to the business using the system, not its vendor.",
        changed: ["eu-hr-provider", "eu-hr-deployer", "eu-fria", "co-admt-deployer", "co-admt-developer", "us-credit", "ca-admt", "ca-risk"], controls: ["C16"] },
    { version: "0.4.0", date: "2026-10-17", summary: "Regulatory watch added. Australian Commonwealth requirement now cites the DTA directly; the exact December 2026 day is marked for verification.",
        changed: ["au-cth"] },
];
function cmp(a, b) {
    const pa = a.split(".").map(Number), pb = b.split(".").map(Number);
    for (let i = 0; i < 3; i++)
        if ((pa[i] ?? 0) !== (pb[i] ?? 0))
            return (pa[i] ?? 0) - (pb[i] ?? 0);
    return 0;
}
/** What changed between the version a system was assessed against and the current library, for that system. */
export function changesSince(assessedVersion, profile) {
    const applies = new Set(obligations(profile).map((o) => o.id));
    return LIBRARY_RELEASES
        .filter((r) => cmp(r.version, assessedVersion) > 0 && cmp(r.version, LIBRARY_VERSION) <= 0)
        .map((release) => ({
        release,
        affects: [...(release.added ?? []), ...(release.changed ?? [])].filter((id) => applies.has(id)),
        controls: release.controls ?? [],
    }));
}
//# sourceMappingURL=releases.js.map